export enum UserInvitationButtonMode {
  Resend = 'resend',
  Cancel = 'cancel',
}
